<template>

  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="asset_owner" label="Asset Owner">
                    <model-select
                      id="asset_owner"
                      :options="listAssetOwner"
                      v-model="owner"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export data Assets</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";

export default {
  name: "report_data_assets",
  components: {
    loading,
    ModelSelect
  },
  data() {
    return {
      loading: false,
      listAssetOwner: [],
      owner: null,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
      this.getOwner();
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        this.loading = true;
        console.log(this.owner)
        this.axios({
          url: "web/export/assets/data-assets/" + this.owner,
          method: "GET",
          responseType: "blob"
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "data_assets.xlsx");
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.expired(error, "");
            }
          })
          .finally(() => {
            this.loading = false;
          });
        //window.location.href = axios.defaults.baseURL+'web/export/data-employee/';
      }
    },
    getOwner: function() {
      this.axios
        .get("web/dropdown/asset-owner/")
        .then(response => {
          this.listAssetOwner =
            response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  

  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
